import { Fragment, useState } from 'react';
import './footer.scss';
import { useStaticQuery, graphql } from 'gatsby';
import Follows from '../follows/follows';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {
    normalizeTwoWords,
    findTarget,
} from '../../../shared/utils/stringUtilities';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import Button from '../../atoms/button/button';

interface StoreInterface {
    link?: string;
    title: string;
    file: {
        url: string;
    };
}

interface FooterInterface {
    nombreCategoria: string;
    noVisibleFooter: boolean;
    hyperLink: string;
    referenciaSubcategorias: {
        tituloPrincipal: string;
        link: string;
        slug: string;
        nombreSubcategoria: string;
        tipoCampo: string;
        appStore: StoreInterface;
        playStore: StoreInterface;
    }[];
}

interface Footer2Interface {
    tituloPrincipal: string;
    descripcion: {
        raw: any;
    };
    logoVigiladosVertical: StoreInterface;
    logoAsocajas: StoreInterface;
    logoRedPactoGlobal: StoreInterface;
}

const Footer = (props: {
    isSuperFooter: boolean;
    bigSide: boolean;
    content?: any;
}) => {
    const data = useStaticQuery(graphql`
        query GET_PORTAL_SERVICIOS_FOOTER_DATA {
            allContentfulMenuLoggin {
                nodes {
                    logoGray {
                        title
                        file {
                            url
                        }
                        gatsbyImageData(
                            formats: [AUTO, WEBP]
                            placeholder: BLURRED
                        )
                    }
                }
            }
            allContentfulFooter(
                filter: { titulo: { eq: "Footer portal servicios" } }
            ) {
                nodes {
                    categorias {
                        nombreCategoria
                        hyperLink
                        referenciaSubcategorias {
                            link
                            nombreSubcategoria
                            tituloPrincipal
                            tipoCampo
                        }
                    }
                    footerSection2 {
                        tituloPrincipal
                        logoAsocajas {
                            title
                            file {
                                url
                                fileName
                            }
                            gatsbyImageData(
                                formats: [AUTO, WEBP]
                                placeholder: BLURRED
                            )
                        }
                        logoRedPactoGlobal {
                            title
                            file {
                                url
                                fileName
                            }
                            gatsbyImageData(
                                formats: [AUTO, WEBP]
                                placeholder: BLURRED
                            )
                        }
                        descripcion {
                            raw
                        }
                        logoVigiladosHorizontal {
                            title
                            file {
                                url
                                fileName
                            }
                            gatsbyImageData(
                                formats: [AUTO, WEBP]
                                placeholder: BLURRED
                            )
                        }
                        logoVigiladosVertical {
                            title
                            file {
                                fileName
                                url
                            }
                            gatsbyImageData(
                                formats: [AUTO, WEBP]
                                placeholder: BLURRED
                            )
                        }
                    }
                    centralLlamadas
                }
            }
        }
    `);

    const titleCallCenter: string =
        data?.allContentfulFooter?.nodes[0]?.centralLlamadas ||
        props?.content?.allContentfulFooter?.nodes[0]?.centralLlamadas;
    const linkTitleCallCenter =
        data?.allContentfulFooter?.nodes[0]?.categorias[8]?.hyperLink;
    const queryFooter: FooterInterface[] =
        data?.allContentfulFooter?.nodes[0]?.categorias ||
        props?.content?.allContentfulFooter?.nodes[0]?.categorias;
    const queryFooter2: Footer2Interface =
        data?.allContentfulFooter?.nodes[0]?.footerSection2[0] ||
        props?.content?.allContentfulFooter?.nodes[0]?.footerSection2[0];
    const logoGray =
        data?.allContentfulMenuLoggin?.nodes[0]?.logoGray ||
        props?.content?.allContentfulMenuLoggin?.nodes[0]?.logoGray;

    const [selectIndex, setSelectIndex] = useState(-1);

    const toggleButton = (index: number) => {
        setSelectIndex(selectIndex === index ? -1 : index);
    };
    const { window } = useBrowserMode();

    const getNormalItems = (items: FooterInterface[]) =>
        items.map((val: FooterInterface, key: number) =>
            !val?.noVisibleFooter ? (
                <div className="f-container__one" key={key}>
                    <span
                        className={`f-container__one__title mode-mobile ${
                            key === selectIndex ? 'mode-mobile__show' : ''
                        }`}
                        onClick={() => toggleButton(key)}
                    >
                        {val.nombreCategoria}
                    </span>
                    <ul className="f-container__one__list">
                        {val.referenciaSubcategorias.map((subVal, key) => {
                            const gtm = `gtm${normalizeTwoWords(
                                val.nombreCategoria
                            )}${normalizeTwoWords(subVal.nombreSubcategoria)}`;
                            const ref =
                                subVal.tituloPrincipal === 'Tienda Comfama'
                                    ? window?.location?.hostname === 'localhost'
                                        ? '/tienda'
                                        : '/portal-servicios/tienda'
                                    : subVal.link;
                            return (
                                <li
                                    className={`f-container__one__list__li ${gtm}`}
                                    key={key}
                                >
                                    <a
                                        className={gtm}
                                        aria-label={subVal.nombreSubcategoria}
                                        href={ref}
                                        target={
                                            subVal.tituloPrincipal ===
                                            'Tienda Comfama'
                                                ? '_self'
                                                : '_blank'
                                        }
                                        rel={
                                            subVal.tituloPrincipal ===
                                            'Tienda Comfama'
                                                ? undefined
                                                : 'noopener noreferrer'
                                        }
                                    >
                                        {subVal.tituloPrincipal ===
                                            'Notificaciones judiciales:' &&
                                            subVal.tituloPrincipal}
                                        {subVal.nombreSubcategoria}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ) : (
                <></>
            )
        );

    const getCallCenterItems = (
        items: FooterInterface[],
        title: string | null,
        classP: string,
        classTitle: string
    ) => (
        <div className={`f-container__one ${classP}`}>
            {title && linkTitleCallCenter ? (
                <Button
                    isDisabled={true}
                    type={'link'}
                    text={title}
                    strictCss={true}
                    gtmMark={`gtm${normalizeTwoWords(title)}`}
                    href={linkTitleCallCenter}
                    classname="f-container__one__title"
                />
            ) : (
                <span className="f-container__one__title">{title}</span>
            )}
            {items.map((val, key) => (
                <Fragment key={key}>
                    {val.referenciaSubcategorias[0].link ? (
                        <a
                            className={`f-container__one__title ${classTitle}`}
                            href={val.referenciaSubcategorias[0].link}
                            target={findTarget(
                                val.referenciaSubcategorias[0].link
                            )}
                            rel="noopener noreferrer"
                            title={val.nombreCategoria}
                        >
                            {val.nombreCategoria}
                        </a>
                    ) : (
                        <span
                            className={`f-container__one__title ${classTitle}`}
                        >
                            {val.nombreCategoria}
                        </span>
                    )}
                    <ul className="f-container__one__list">
                        {val.referenciaSubcategorias.map((subVal, key) => (
                            <li
                                className="f-container__one__list__li"
                                key={key}
                            >
                                <a
                                    rel="noopener noreferrer"
                                    href={`tel:${subVal.nombreSubcategoria}`}
                                >
                                    <i className="icon-phone" />
                                    {subVal.nombreSubcategoria}
                                </a>
                            </li>
                        ))}
                    </ul>
                </Fragment>
            ))}
        </div>
    );

    return (
        <footer className="m-footer">
            <div
                className={
                    'f-container ' + (props.bigSide ? '__big-side-left' : '')
                }
            >
                {getNormalItems(queryFooter.slice(0, 4))}
                {getCallCenterItems(
                    queryFooter.slice(4, 6),
                    titleCallCenter,
                    'call',
                    'title_sub'
                )}
                {getCallCenterItems(
                    queryFooter.slice(6, 7),
                    titleCallCenter,
                    'call call-hide',
                    'title_sub'
                )}
                <div className="f-container__one call">
                    <Follows query={queryFooter[7]} />
                </div>
            </div>
            <div
                className={
                    'f-final-content ' +
                    (props.bigSide ? '__big-side-left' : '')
                }
            >
                <div className="f-final-content__box">
                    <span className="f-final-content__box__title">
                        {queryFooter2.tituloPrincipal}
                    </span>
                    <div className="f-final-content__box__imgs">
                        <img
                            loading="lazy"
                            className="f-final-content__box__imgs__img"
                            src={
                                queryFooter2.logoAsocajas &&
                                queryFooter2.logoAsocajas.file.url
                            }
                            alt={'Logo Asocajas'}
                        />
                        <img
                            loading="lazy"
                            className="f-final-content__box__imgs__img"
                            src={
                                queryFooter2.logoRedPactoGlobal &&
                                queryFooter2.logoRedPactoGlobal.file.url
                            }
                            alt={'Logo Red Pacto Global'}
                        />
                    </div>
                    <article className="f-final-content__box__body">
                        {queryFooter2.descripcion.raw &&
                            documentToReactComponents(
                                JSON.parse(queryFooter2.descripcion.raw)
                            )}
                    </article>
                </div>
                <div
                    className={`f-final-content__zone${
                        props.isSuperFooter
                            ? ' f-final-content__zone--super'
                            : ''
                    }`}
                >
                    <img
                        loading="lazy"
                        className="f-final-content__zone__logo"
                        src={logoGray && logoGray.file.url}
                        alt={logoGray.title}
                    />
                    <div className="f-final-content__zone__final">
                        <button
                            className="f-final-content__zone__final__button icon-arrow-up"
                            onClick={() =>
                                scroll({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth',
                                })
                            }
                            aria-label="Ir arriba"
                        />
                        <img
                            loading="lazy"
                            src={
                                queryFooter2.logoVigiladosVertical &&
                                queryFooter2.logoVigiladosVertical.file.url
                            }
                            alt={queryFooter2.logoVigiladosVertical.title}
                        />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
